import React, {useContext, useEffect, useState} from "react";
import SideMenu from "../SideMenu";
import {Wrapper} from "./Layout.styles";
import {UserContext} from "../../context/UserContext";
import {Button, Drawer, Layout, Menu, theme} from 'antd';
import {useNavigate} from "react-router-dom";
import Logo from "../../assets/logo.svg";
import LogoSmall from "../../assets/logo-small.png";
import HomeIcon from "../../assets/home.svg";
import './layout.style.css';
import PatientListIcon from "../../assets/patient-list.svg";
import AIGlaciesIcon from "../../assets/ai_glacies.svg";
import {useTranslation} from "react-i18next";
import {
    CommentOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UsergroupAddOutlined
} from "@ant-design/icons";
import ProfileIcon from "../../assets/profile.svg";
import HelpIcon from "../../assets/Help.svg";
import OrgIcon from "../../assets/system.png";
import ProfileComponent from "./Profile/profile.component";
import PatientSearchComponent from "./Profile/patient-search.component";
import BellNotification from "./Notifications/notification-bell.component";
import {FeedbackFish} from "@feedback-fish/react";

const {Header, Content, Footer, Sider} = Layout;

const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
    background: '#1a1625',
};

const headerStyle = {
    paddingLeft: 0,
    paddingRight: 12,
    background: '#1a1625',
    display: 'flex',
    justifyContent: 'space-between',

}

const LayoutComponent = ({children}) => {
    const navigate = useNavigate();
    const {t} = useTranslation("common");

    //TODO: New layout
    const newLayout = true;

    const [collapsed, setCollapsed] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [current, setCurrent] = useState('home');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    const {logoutUser, user} = useContext(UserContext);

    // Handle window resize to determine mobile view
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 992;
            setIsMobile(mobile);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onClose = () => {
        setIsOpen(false);
    };

    const triggerSideMenu = () => {
        if (isMobile) {
            setIsOpen(!isOpen);
        } else {
            setCollapsed(!collapsed);
        }
    };

    const handleLogout = () => {
        logoutUser();
        navigate('/login');
    };

    if (!user) {
        return (<div>{children}</div>);
    }

    if (!newLayout) {
        return (
            <Wrapper>
                <SideMenu/>
                {children}
            </Wrapper>
        );
    }

    const menuItems = () => {
        return (
            <Menu
                theme="dark"
                mode="inline"
                style={{
                    background: '#1a1625',
                }}
                defaultSelectedKeys={[current]}
                items={[
                    {
                        key: 'home',
                        icon: <img src={HomeIcon} alt="home"/>,
                        label: t('home'),
                        onClick: () => {
                            setCurrent('home');
                            navigate('/dashboard');
                            if (isMobile) setIsOpen(false);
                        }
                    },
                    {
                        key: 'patient-list',
                        icon: <img src={PatientListIcon} alt={t('patient_list')}/>,
                        label: t('patient_list'),
                        onClick: () => {
                            setCurrent('patient-list');
                            navigate('/patient-list');
                            if (isMobile) setIsOpen(false);
                        }
                    },
                    {
                        key: 'glacies-ai',
                        icon: <img src={AIGlaciesIcon} alt="AI Glacies" width={24}/>,
                        label: 'Try Glacies AI',
                        onClick: () => {
                            setCurrent('glacies-ai');
                            navigate('/glacies-ai');
                            if (isMobile) setIsOpen(false);
                        }
                    },
                    {
                        key: 'profile',
                        icon: <img src={ProfileIcon} alt="Profile"/>,
                        label: t('profile'),
                        onClick: () => {
                            setCurrent('profile');
                            navigate('/profile');
                            if (isMobile) setIsOpen(false);
                        }
                    },
                    {
                        key: 'help-page',
                        icon: <img src={HelpIcon} alt="Help" width={28}/>,
                        label: t('help'),
                        onClick: () => {
                            setCurrent('help-page');
                            navigate('/help-page');
                            if (isMobile) setIsOpen(false);
                        }
                    },
                    {
                        key: 'organization',
                        icon: <img src={OrgIcon} alt="Org" width={24}/>,
                        label: t('organization'),
                        onClick: () => {
                            setCurrent('organization');
                            navigate('/organization');
                            if (isMobile) setIsOpen(false);
                        },
                        style: {display: user.role === 'ORGANIZATION_ADMIN' ? 'block' : 'none'}
                    },
                    {
                        key: 'partner-referrals',
                        icon: <UsergroupAddOutlined style={{fontSize: 24}}/>,
                        label: 'B2C referrals',
                        onClick: () => { setCurrent('partner-referrals'); navigate('/partner-referrals'); if (isMobile) setIsOpen(false); },
                        style: {display: user.role === 'ORGANIZATION_ADMIN' ? 'flex' : 'none'}
                    },
                    {
                        key: 'partner-kits',
                        icon: <UsergroupAddOutlined style={{fontSize: 24}}/>,
                        label: 'Kit inventory',
                        onClick: () => { setCurrent('partner-kits'); navigate('/partner-kits'); if (isMobile) setIsOpen(false); },
                        style: {display: user.role === 'ORGANIZATION_ADMIN' ? 'flex' : 'none'}
                    },
                    {
                        key: 'org-users',
                        icon: <UsergroupAddOutlined style={{
                            fontSize: 24
                        }}/>,
                        label: t('org-users'),
                        onClick: () => {
                            setCurrent('org-users');
                            navigate('/org-users');
                            if (isMobile) setIsOpen(false);
                        },
                        style: {display: user.role === 'ORGANIZATION_ADMIN' ? 'flex' : 'none'}
                    },
                    {
                        key: 'logout',
                        icon: <LogoutOutlined style={{fontSize: 24}}/>,
                        label: t('logout'),
                        onClick: handleLogout,
                        style: {display: 'flex'}
                    }
                ]}
            />
        );
    };

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };

    const onSearch = (value) => {
        console.log('search:', value);
    };


    return (
      <Layout
      // siderBg
      >
        <Sider
          style={siderStyle}
          breakpoint="lg"
          collapsedWidth={isMobile ? "0" : "80"}
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            // If it breaks to mobile view, update isMobile state
            setIsMobile(broken);
            if (broken) {
              setCollapsed(true); // Collapse the sider in mobile view
            }
          }}
          onCollapse={(collapsed, type) => {
            // Only update collapsed state if not triggered by the button
            if (type === "responsive") {
              setCollapsed(collapsed);
            }
          }}
        >
          <div className="demo-logo-vertical" />
          {collapsed && !isMobile ? (
            <img
              className="logo-slider logo-small"
              onClick={() => navigate("/")}
              src={LogoSmall}
              alt="logo"
            />
          ) : (
            <img
              className="logo-slider"
              onClick={() => navigate("/")}
              src={Logo}
              alt="logo"
            />
          )}
          {menuItems()}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <FeedbackFish projectId="7e2df4ec8817c7" userId={user.email}>
              <Button
                type="text"
                icon={<CommentOutlined />}
                size="large"
                style={{
                  color: "#fff",
                  paddingLeft: collapsed ? 0 : "28px",
                  marginLeft: collapsed ? "-8px" : "0px",
                  display: "flex",
                  justifyContent: collapsed ? "center" : "flex-start",
                  width: "100%",
                  border: "none",
                }}
              >
                {!collapsed && "Feedback"}
              </Button>
            </FeedbackFish>
          </div>
        </Sider>
        <Layout>
          <Header style={headerStyle}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={triggerSideMenu}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />

            <PatientSearchComponent />
            <BellNotification />
            <ProfileComponent user={user} />
          </Header>
          <Content
            style={{
              minHeight: 280,
              background: "#111018",
            }}
          >
            {children}
          </Content>
        </Layout>
        {isMobile && (
          <Drawer
            title="Menu"
            onClose={onClose}
            open={isOpen}
            placement="left"
            key="left"
            destroyOnClose={true}
            style={{
              backgroundColor: "#1a1625",
            }}
          >
            {menuItems()}
          </Drawer>
        )}
      </Layout>
    );
};

export default LayoutComponent;
